var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiquidity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.307 19.6315C12.0873 19.6315 12.7199 18.0056 12.7199 15.9998C12.7199 13.9941 12.0873 12.3682 11.307 12.3682C10.5266 12.3682 9.89404 13.9941 9.89404 15.9998C9.89404 18.0056 10.5266 19.6315 11.307 19.6315Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0712 22.1579C18.0015 22.1579 18.7557 19.4008 18.7557 15.9998C18.7557 12.5988 18.0015 9.8418 17.0712 9.8418C16.1409 9.8418 15.3867 12.5988 15.3867 15.9998C15.3867 19.4008 16.1409 22.1579 17.0712 22.1579Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2642 24C22.7292 24 23.1061 20.4183 23.1061 16C23.1061 11.5817 22.7292 8 22.2642 8C21.7993 8 21.4224 11.5817 21.4224 16C21.4224 20.4183 21.7993 24 22.2642 24Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiquidity);
export default __webpack_public_path__ + "static/media/liquidity.8dca8b52d99faf18f173b860e4cefa24.svg";
export { ForwardRef as ReactComponent };